import { AuthReducer, FirebaseReducer, LegalsReducer } from '@web_opxp/features';
import { LanguageReducer } from '@web_opxp/language';
import { combineReducers } from 'redux';
import { CouponReducer } from '../../coupon';
import * as CheckoutReducer from '../slice';

export default combineReducers({
  [AuthReducer.statePropName]: AuthReducer.default,
  [LanguageReducer.statePropName]: LanguageReducer.default,
  [FirebaseReducer.statePropName]: FirebaseReducer.default,
  [CouponReducer.statePropName]: CouponReducer.default,
  [CheckoutReducer.statePropName]: CheckoutReducer.default,
  [LegalsReducer.statePropName]: LegalsReducer.default,
});
